/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
export const REGEX_VALIDATION_PATTERNS = {
  EMAIL: "[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}"
};
